import { render } from "./AufbissInfo.vue?vue&type=template&id=384c0b4e"
import script from "./AufbissInfo.vue?vue&type=script&lang=js"
export * from "./AufbissInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__